var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.anchorLinkClasses},[_vm._ssrNode("<a"+(_vm._ssrAttr("href",_vm.href))+(_vm._ssrAttr("data-scroll-offset",_vm.scrollOffset))+(_vm._ssrAttr("data-href",_vm.href))+(_vm._ssrAttr("title",_vm.title))+(_vm._ssrClass(null,_vm.linkTitleClasses))+">"+_vm._ssrEscape(_vm._s(_vm.title))+"</a> "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48e3a74d","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/anchor/anchor-link.vue
// module id = 544
// module chunks = 0 1 28